import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SideNavComponent } from './layout/side-nav/side-nav.component';
import { HeaderComponent } from './layout/header/header.component';
import { NotAllowedComponent } from './layout/not-allowed/not-allowed.component';
import { MaterialModule } from './material/material.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideCalAngular } from '@cvx/cal-angular';
import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeRu from '@angular/common/locales/ru';
import localeKk from '@angular/common/locales/kk';
import {
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { API_BASE_URL, Client } from './api/api-clientInformation';
import { authInterceptor } from './services/auth.interceptor';
import { loaderInterceptor } from './services/loader.interceptor';
import { ChunkLoadErrorHandler } from './services/chunk-load-error.handler';
import { AppTitleStrategy } from './services/app-title.strategy';
import { TitleStrategy } from '@angular/router';
import { provideSessionAudit } from './services/session-audit/session-audit.initializer';
import { ToastrModule } from 'ngx-toastr';
import { MAT_TABS_CONFIG } from '@angular/material/tabs';
import { provideAnimations } from '@angular/platform-browser/animations';
import { SharedModule } from './features/shared/shared.module';
import { environment } from '../environments/environment';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader, TRANSLATE_HTTP_LOADER_CONFIG } from '@ngx-translate/http-loader';

registerLocaleData(localeEn);
registerLocaleData(localeRu);
registerLocaleData(localeKk);

@NgModule({
  declarations: [AppComponent, SideNavComponent, HeaderComponent, NotAllowedComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MaterialModule,
    MatMomentDateModule,
    SharedModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right',
    }),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useClass: TranslateHttpLoader,
      },
    }),
  ],
  providers: [
    { provide: TRANSLATE_HTTP_LOADER_CONFIG, useValue: { prefix: './assets/i18n/', suffix: '.json' } },
    provideCalAngular(environment),
    { provide: ErrorHandler, useClass: ChunkLoadErrorHandler },
    { provide: LOCALE_ID, useValue: 'en' },
    // { provide: MAT_DATE_LOCALE, useValue: 'en' },
    provideAnimations(),
    provideHttpClient(
      withInterceptors([authInterceptor, loaderInterceptor])
    ),
    provideSessionAudit(),
    { provide: TitleStrategy, useExisting: AppTitleStrategy },
    Client,
    {
      provide: API_BASE_URL,
      useValue: environment.apiUrl,
    },
    {
      provide: MAT_TABS_CONFIG,
      useValue: { stretchTabs: false },
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
